import { getRates } from '../../cred';
import { waitMaadi, hasOwn } from '../../customLib';

// export const initialCurrRates = {};

export const getRatesIfThere = (coinObj = {}) => {
	if (typeof coinObj === 'object' && hasOwn(coinObj, 'lastTradePrice')) {
		return {
			lastTradePrice: 0,
			yes_price: 0,
			...coinObj,
		};
	}

	return {
		lastTradePrice: 0,
		yes_price: 0,
	};
};

let getRatesCalled = false;

const fillRates = (prevRates, currentRate) => {
	let newRates = prevRates;
	let usdtRate = 0;

	currentRate.forEach(coinObj => {
		const coinName = Object.keys(coinObj)[0];
		const coinRate = getRatesIfThere(coinObj[coinName]);

		if (coinName === 'BTCUSDT' && coinRate.lastTradePrice > 0) {
			const { lastTradePrice, inr_price } = coinRate;

			usdtRate = inr_price / lastTradePrice;
		}

		newRates = {
			...newRates,
			[coinName]: coinRate,
		};
	});

	return {
		currentRate: newRates,
		lastRateUpdated: Date.now(),
		usdtRate,
	};
};

export const fillStaticRates = (currentRate = {}) => {
	if (
		hasOwn(currentRate[0], 'BTC') &&
		hasOwn(currentRate[0].BTC, 'lastTradePrice')
	) {
		return fillRates({}, currentRate);
	}

	return {};
};

const __getTicker = async state => {
	if (Date.now() - state.lastRateUpdated < 1000) {
		await waitMaadi(1500);
	}
	try {
		getRatesCalled = true;
		const currentRate = await getRates();
		getRatesCalled = false;

		if (
			Array.isArray(currentRate) &&
			typeof currentRate[0] === 'object' &&
			hasOwn(currentRate[0], 'BTC') &&
			hasOwn(currentRate[0].BTC, 'lastTradePrice')
		) {
			let newRates = state.currentRate;
			let usdtRate = 0;

			currentRate.forEach(coinObj => {
				const coinName = Object.keys(coinObj)[0];
				const coinRate = getRatesIfThere(coinObj[coinName]);

				let newCoinName;

				if (coinName === 'BTCUSDT' && coinRate.lastTradePrice > 0) {
					const { lastTradePrice, inr_price } = coinRate;

					usdtRate = inr_price / lastTradePrice;
				}
				switch (coinName) {
					// case 'BCH':
					// 	newCoinName = 'BCHABC';
					// 	break;

					case 'STORM':
						newCoinName = 'STMX';
						break;
					case 'NPXS':
						newCoinName = 'PUNDIX';
						break;
					case 'GNT':
						newCoinName = 'GLM';
						break;
					case 'NPXSUSDT':
						newCoinName = 'PUNDIXUSDT';
						break;
					// case 'BCHUSDT':
					// 	newCoinName = 'BCHABCUSDT';
					// 	break;
					default:
						newCoinName = coinName;
						break;
				}

				newRates = {
					...newRates,
					[newCoinName]: coinRate,
				};
			});

			return {
				currentRate: newRates,
				usdtRate,
				lastRateUpdated: Date.now(),
			};
		}

		return {};
	} catch (err) {
		console.log('rates:', err);
	}
};

const __updateCurrentCoinRate = (state, coin, val, market) => {
	let upperCoin = coin.toUpperCase();

	switch (market) {
		case 1:
			upperCoin = `${coin.toUpperCase()}USDT`;
			break;
		default:
			upperCoin = coin.toUpperCase();
	}
	const { currentRate } = state;

	if (getRatesCalled === true) {
		setTimeout(() => {
			__updateCurrentCoinRate(state, coin, val, market);
		}, 2000);
	} else {
		return {
			currentRate: {
				...currentRate,
				[upperCoin]: {
					...currentRate[upperCoin],
					lastTradePrice: val,
				},
			},
			lastRateUpdated: Date.now(),
		};
	}
};

export const tickerActions = {
	/**
	 * Ticker:
	 */
	__getTicker,
	__updateCurrentCoinRate,
	__fillStaticRates: (_, currentRate) => fillStaticRates(currentRate),
	__fillStaticUSDTRates: (_, usdtRate) => ({ usdtRate }),
};
